import React from 'react';
import PropTypes from 'prop-types';
import Chips, { ChipType } from '@/componentsDS/Chips/Chips';

const ChipField = ({ chipValues, chipInputMultiple, disabled, onRemoveChip, onRemoveAll }) => {
    if (!chipValues?.length) return null;

    if (chipInputMultiple) {
        return (
            <Chips
                label={chipValues.length === 1 ? chipValues[0].label : `${chipValues.length} Selected`}
                size="small"
                onRemove={onRemoveAll}
                readOnly={disabled}
                type={ChipType.INPUT}
            />
        );
    }

    return chipValues.map((chip) => (
        <Chips
            key={chip.id}
            label={chip.label}
            size="small"
            onRemove={() => onRemoveChip(chip.id)}
            readOnly={disabled}
            type={ChipType.INPUT}
        />
    ));
};

ChipField.propTypes = {
    chipValues: PropTypes.arrayOf(PropTypes.object),
    chipInputMultiple: PropTypes.bool,
    disabled: PropTypes.bool,
    onRemoveChip: PropTypes.func.isRequired,
    onRemoveAll: PropTypes.func.isRequired,
};

export default ChipField;
